var DATA = require("../../data/aqi_ulaanbaatar.sheet.json");
var DATA_COMPARISON = require("../../data/aqi_comparison.sheet.json");
var AQI_VALUES = require("../../data/aqi_key.sheet.json");

var skipLabels = [ 'label', 'values' ];

var x_ticks = [];

var { isMobile, isTablet } = require("./lib/breakpoints");
var $ = require("./lib/qsa");

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-interpolate/dist/d3-interpolate.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min")
};

var classify = require("./lib/classify");
var debounce = require("./lib/debounce");
var getAPMonth = require("./lib/getAPMonth");
var makeTranslate = require("./lib/makeTranslate");
var wrapText = require("./lib/wrapText");

var fmtComma = s => s.toLocaleString().replace(/\.0+$/, "");
var fmtYearAbbrev = d => (d.getFullYear() + "").slice(-2);
var fmtYearFull = d => d.getFullYear();

var formatAQIData = function() {
  DATA.forEach(function(d) {
    var [m, day, y] = d.date.split("/").map(Number);
    d.date = new Date(y, m - 1, day);
    // d['date'] = d3.time.format('%m/%d/%Y').parse(d['date']);
    d.values = [];
    d.total = d.max - d.min;

    if (d.date.getDate() === 1 || d.date.getDate() === 1) {
      x_ticks.push(d['date']);
    }

    // Air quality thresholds
    var thresholds = [ 50, 100, 150, 200, 300, 9999 ];
    var th_labels = AQI_VALUES.map(o => o['label']); // equivalent of underscore _.pluck
    var lower = parseFloat(d.min);

    for (var i=0; i < thresholds.length; i++) {
      var th = thresholds[i];
      var y0 = lower;
      var min = parseFloat(d['min']);
      var max = parseFloat(d['max']);

      if (isNaN(min)) {
        y0 = 0;
        y1 = 0;
        lower = 0;
      } else if (th < min) {
        y1 = min;
        lower = min;
      } else if (th < max) {
        y1 = th;
        lower = th;
      } else {
        y1 = max;
        lower = max;
      }

      d.values.push({
          'name': th_labels[i],
          'y0': y0,
          'y1': y1,
          'val': y1 - y0,
          'avg': !isNaN(d['avg']) ? d['avg'] : null
        });
    }
  });

  DATA_COMPARISON.forEach(function(d) {
    var x0 = 0;
    d.values = [];

    for (var key in d) {
      if (skipLabels.indexOf(key) > -1) {
        continue;
      }

      d[key] = Number(d[key]);

      var x1 = x0 + d[key];

      d.values.push({
        'name': key,
        'x0': x0,
        'x1': x1,
        'val': d[key]
      })

      x0 = x1;
    }
  });
}

var renderAQIUlaanbaatar = function() {
  /*
   * Setup
   */
  var config = {
    container: '#air-quality-ulaanbaatar',
    data: DATA
  }

  var container = document.querySelector(config.container);
  config.width = container.offsetWidth;

  var labelColumn = 'date';

  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 9;
  var valueGap = 6;

  var margins = {
      top: 5,
      right: 70,
      bottom: 25,
      left: 40
  };

  var ticksY = 5;
  var roundTicksFactor = 100;

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = Math.ceil((config.width * aspectHeight) / aspectWidth);

  if (chartHeight > 350) {
      chartHeight = 350;
  }

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html('');

  /*
   * Create D3 scale objects.
   */
  var dates = config.data.map(d => d.date);
  var extent = [dates[0], dates[dates.length - 1]];
  var xScale = d3.scaleTime()
      .domain(extent)
      .range([ 0, chartWidth ]);

  var values = config.data.map(d => d.total).filter(function(d,i) {
    return !isNaN(d);
  });
  var floors = values.map(
    v => Math.floor(v / roundTicksFactor) * roundTicksFactor
  );
  var ceilings = values.map(
    v => Math.ceil(v / roundTicksFactor) * roundTicksFactor
  );

  var min = Math.min(...floors);
  var max = Math.max(...ceilings);

  if (min > 0) {
    min = 0;
  }

  var yScale = d3.scaleLinear()
    .domain([ min, max ])
    .rangeRound([ chartHeight, 0 ]);

  var bar_w = (chartWidth / config.data.length) > 2 ? (chartWidth / config.data.length): (chartWidth / config.data.length);

  /*
   * Create the root SVG element.
   */
  var chartWrapper = containerElement.append('div')
    .attr('class', 'graphic-wrapper');

  var chartElement = chartWrapper.append('svg')
    .attr('width', config.width)
    .attr('height', chartHeight + margins.top + margins['bottom'])
    .append('g')
        .attr('transform', makeTranslate(margins.left, margins.top));

  /*
   * Create D3 axes.
   */
  var ticksX = x_ticks;
  if (isMobile) {
      ticksX = [ x_ticks[0], x_ticks[3], x_ticks[6], x_ticks[9], x_ticks[12] ];
  }

  var xAxis = d3.axisBottom()
    .scale(xScale)
    .tickValues(ticksX)
    .tickFormat(function(d) {
      return getAPMonth(d);
    });

  var yAxis = d3.axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(function(d) {
      return fmtComma(d);
    });

  /*
   * Render axes to chart.
   */
  chartElement.append('g')
    .attr('class', 'x axis')
    .attr('transform', makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement.selectAll('.x.axis text')
    .attr('dy', '10px');

  chartElement.append('g')
    .attr('class', 'y axis')
    .call(yAxis);

  /*
   * Render grid to chart.
   */
  var yAxisGrid = function() {
    return yAxis;
  };

  chartElement.append('g')
    .attr('class', 'y grid')
    .call(yAxisGrid()
      .tickSize(-chartWidth, 0)
      .tickFormat('')
    );

  /*
   * Render bars to chart.
   */
  var bars = chartElement.selectAll('.bar')
    .data(config.data)
    .enter().append('g')
      .attr('class', 'bar')
      .attr('transform', function(d) {
        return makeTranslate(xScale(d[labelColumn]), 0);
      });

  bars.selectAll('rect')
    .data(function(d) {
      return d.values;
    })
    .enter().append('rect')
      .attr('y', function(d) {
        if (d['y1'] < d['y0']) {
          return yScale(d['y0']);
        }
        return yScale(d['y1']);
      })
      .attr('width', bar_w)
      .attr('height', function(d) {
        return Math.abs(yScale(d['y0']) - yScale(d['y1']));
      })
      .attr('class', function(d) {
        return classify(d.name);
      });

  // Add average
  var line = d3.line()
    .curve(d3.curveStepAfter)
    .defined(function(d) {
      return d['avg'] != null && d['avg'] != 0;
    })
    .x(d => xScale(d[labelColumn]))
    .y(d => yScale(d['avg']));

  chartElement.append('g')
    .attr('class', 'lines')
    .selectAll('path')
    .data([ config.data ])
    .enter()
    .append('path')
      .attr('class', function(d, i) {
        return 'line';
      })
      .attr('d', function(d) {
        return line(d);
      });

  /*
   * Render side labels
   */
  var annos_g = chartElement.append('g')
    .attr('class', 'annos-g');

  var last_item = config.data[config.data.length - 2];

  annos_g.append('line')
    .attr('class', 'anno-leader anno-avg')
    .attr('x1', chartWidth - bar_w + 2)
    .attr('x2', chartWidth + bar_w + 10)
    .attr('y1', yScale(last_item['avg']) - 1)
    .attr('y2', yScale(last_item['avg']) - 1)

  annos_g.append('text')
    .attr('class', 'anno-label anno-avg')
    .attr('x', chartWidth + bar_w + 12)
    .attr('y', yScale(last_item['avg']) + 3)
    .text('Daily average')
    .call(wrapText, config.width - chartWidth - margins.left - 15, 13)
}

var renderAQIComparison = function() {
  var config = {
    container: '#air-quality-comparison',
    data: DATA_COMPARISON
  }

  var container = document.querySelector(config.container);
  config.width = container.offsetWidth;

  var labelColumn = 'label';

  var barHeight = 30;
  var barGap = 5;
  var labelWidth = 90;
  var labelMargin = 10;
  var valueGap = 6;
  var maxWidth = 650;

  var margins = {
    top: 0,
    right: 30,
    bottom: 25,
    left: (labelWidth + labelMargin)
  };

  var ticksX = [ 0, 100, 200, 300, 365 ];

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  if (config.width > maxWidth) {
    chartWidth = maxWidth - margins.left - margins.right;
  }
  var chartHeight = ((barHeight + barGap) * config.data.length);

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html('');

  /*
   * Create D3 scale objects.
   */
  var min = 0;
  var max = 365;

  var xScale = d3.scaleLinear()
    .domain([ min, max ])
    .rangeRound([ 0, chartWidth ]);

  /*
   * Create the root SVG element.
   */
  var chartWrapper = containerElement.append('div')
    .attr('class', 'graphic-wrapper');

  var chartElement = chartWrapper.append('svg')
    .attr('width', chartWidth + margins.left + margins.right)
    .attr('height', chartHeight + margins.top + margins['bottom'])
    .append('g')
    .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');

  /*
   * Create D3 axes.
   */
  var xAxis = d3.axisBottom()
    .scale(xScale)
    .tickValues(ticksX)
    .tickFormat(function(d, i) {
      var suffix = i == (ticksX.length - 1) ? ' days' : '';
      return d + suffix;
    });

  /*
   * Render axes to chart.
   */
  chartElement.append('g')
    .attr('class', 'x axis')
    .attr('transform', makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement.selectAll('.x.axis text')
    .attr('dy', '10px');

  /*
   * Render grid to chart.
   */
  var xAxisGrid = function() {
    return xAxis;
  };

  chartElement.append('g')
    .attr('class', 'x grid')
    .attr('transform', makeTranslate(0, chartHeight))
    .call(xAxisGrid()
      .tickSize(-chartHeight, 0, 0)
      .tickFormat('')
    );

  /*
   * Render bars to chart.
   */
  var group = chartElement.selectAll('.group')
    .data(config.data)
    .enter().append('g')
      .attr('class', function(d) {
        return 'group ' + classify(d[labelColumn]);
      })
      .attr('transform', function(d,i) {
        return 'translate(0,' + (i * (barHeight + barGap)) + ')';
      });

  group.selectAll('rect')
    .data(function(d) {
      return d.values;
    })
    .enter().append('rect')
      .attr('x', function(d) {
        if (d.x0 < d.x1) {
          return xScale(d.x0);
        }
        return xScale(d.x1);
      })
      .attr('width', function(d) {
        return Math.abs(xScale(d.x1) - xScale(d.x0));
      })
      .attr('height', barHeight)
      .attr('class', function(d) {
        return classify(d.name);
      });

   /*
    * Render bar values.
    */
   group.append('g')
      .attr('class', 'value')
      .selectAll('text')
      .data(function(d) {
          return d.values;
      })
      .enter().append('text')
          .text(function(d) {
              if (d['val'] != 0) {
                  return d['val'];
              }
          })
          .attr('class', function(d) {
              return classify(d.name);
          })
          .attr('x', function(d) {
      return xScale(d.x1);
          })
          .attr('dx', function(d) {
              var textWidth = this.getComputedTextLength();
              var barWidth = Math.abs(xScale(d.x1) - xScale(d.x0));

              // Hide labels that don't fit
              if (textWidth + valueGap * 2 > barWidth) {
                  d3.select(this).classed('hidden', true)
              }

              if (d.x1 < 0) {
                  return valueGap;
              }

              return -(valueGap + textWidth);
          })
          .attr('dy', (barHeight / 2) + 4)

  /*
   * Render bar labels.
   */
  chartWrapper.append('ul')
      .attr('class', 'labels')
      .attr('style', function() {
        var s = '';
        s += 'width: ' + labelWidth + 'px;';
        s += 'top:' + margins.top + 'px;';
        s += 'left: 0;';
        return s;
      })
      .selectAll('li')
      .data(config.data)
      .enter()
      .append('li')
          .attr('style', function(d, i) {
            var s = '';
            s += 'width: ' + labelWidth + 'px;';
            s += 'height: ' + barHeight + 'px;';
            s += 'left: 0;';
            s += 'top: ' + (i * (barHeight + barGap)) + 'px;';
            return s;
          })
          .attr('class', function(d) {
              return classify(d[labelColumn]);
          })
          .append('span')
              .text(function(d) {
                  return d[labelColumn];
              });
}

/* init everything */
formatAQIData();
renderAQIUlaanbaatar();
renderAQIComparison();

window.addEventListener("resize", debounce(renderAQIUlaanbaatar));
window.addEventListener("resize", debounce(renderAQIComparison));
